import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { useI18n } from "../i18n";

const companyLinks = [
  { key: "services", to: "/services" },
  { key: "about", to: "/about" },
  { key: "guides", to: "/guide" },
  { key: "contact", to: "/contact" },
];

const policyLinks = [
  { key: "terms", to: "/terms" },
  { key: "privacy", to: "/privacy-policy" },
  { key: "refund", to: "/refund-policy" },
  { key: "return", to: "/return-policy" },
  { key: "cancellation", to: "/cancellation-policy" },
  { key: "shipping", to: "/shipping-policy" },
];

const socials = [
  { name: "X / Twitter", href: "https://x.com/OptivraTech7" },
  { name: "Instagram", href: "https://www.instagram.com/optivra_tech/" },
  { name: "Discord", href: "https://discord.gg/hmb5DjVHN3" },
];

const Col = ({ title, children }) => (
  <div>
    <h3 className="mb-4 font-mono text-xs uppercase tracking-[0.16em] text-ink-3">{title}</h3>
    <ul className="space-y-2.5">{children}</ul>
  </div>
);

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="bg-paper">
      <div className="mx-auto w-full max-w-6xl px-5 pt-16 pb-10 sm:px-8 2xl:max-w-7xl">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-12">
          <div className="sm:col-span-2 lg:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <img src={logo} alt="" className="h-8 w-8 object-contain" />
              <span className="text-[1.0625rem] font-semibold tracking-tight text-ink">Optivra Tech</span>
            </Link>
            <p className="mt-5 max-w-sm text-[0.9375rem] leading-relaxed text-ink-2">{t("footer.tagline")}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              <a href="mailto:founder@optivratech.com" className="btn btn-secondary btn-sm">
                founder@optivratech.com
              </a>
              <a href="tel:+918619838718" className="btn btn-secondary btn-sm" dir="ltr">
                +91 86198 38718
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <Col title={t("footer.company")}>
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[0.9375rem] text-ink-2 transition-colors hover:text-brand">
                    {t(`common.nav.${l.key}`)}
                  </Link>
                </li>
              ))}
            </Col>
          </div>

          <div className="lg:col-span-3">
            <Col title={t("footer.policies")}>
              {policyLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[0.9375rem] text-ink-2 transition-colors hover:text-brand">
                    {t(`footer.legal.${l.key}`)}
                  </Link>
                </li>
              ))}
            </Col>
          </div>

          <div className="lg:col-span-2">
            <Col title={t("footer.elsewhere")}>
              {socials.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[0.9375rem] text-ink-2 transition-colors hover:text-brand"
                  >
                    {s.name} ↗
                  </a>
                </li>
              ))}
            </Col>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-line pt-6 text-sm text-ink-3 md:flex-row md:justify-between">
          <p>
            © {new Date().getFullYear()} Optivra Tech · GSTIN 08BNOPS7805R1ZT
          </p>
          <p>C-52, Amar Colony, Udasar Fanta, Jaipur Road, Bikaner, Rajasthan, India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
